// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"ShipstationSettingsList_contentComponent__1CZLN","tableContainer":"ShipstationSettingsList_tableContainer__2lhfH","root":"ShipstationSettingsList_root__3XJo1"};